export const fmtMoney = (n: number): string => {
  const sign = n < 0 ? '-' : ''
  const v = Math.abs(n)
  return (
    sign +
    v.toLocaleString(undefined, {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0,
    })
  )
}

export const fmtPct = (n: number): string => {
  return `${n.toFixed(0)}%`
}

export const clamp = (n: number, min: number, max: number): number => {
  return Math.max(min, Math.min(max, n))
}

export const round0 = (n: number): number => {
  return Math.round(n)
}
